import { FC } from 'react';
import { Stack } from '@chakra-ui/react';

import { getKeyForBlock } from './logic/getKeyForBlock';
import { BlocksRendererProps } from './types/BlocksRendererProps';
import { BlockRenderer } from './BlockRenderer';

export const BlocksRenderer: FC<BlocksRendererProps> = ({
  blocks,
  ...props
}) => (
  <>
    {blocks.map((block, idx) => {
      if (Array.isArray(block)) {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Stack key={idx} direction="row" gap={4}>
            <BlocksRenderer blocks={block} />
          </Stack>
        );
      }

      return (
        <BlockRenderer
          key={getKeyForBlock(block, idx)}
          block={block}
          {...props}
        />
      );
    })}
  </>
);
